const theme = {
  colors: {
    primary: '#009BDF',
    // alphaPrimary: '#009bdf12',
    alphaPrimary: '#f6f6f6',
    alphaPrimaryGradient: 'linear-gradient(151deg, rgba(0,203,241,0.09) 0%, rgba(0,155,223,0.01) 100%)',
    secondary: 'rgb(0, 69, 140)',
    dark: '#0A1F44',
    white: '#ffffff',
    // gray: 'rgb(166, 171, 179)',
    gray: 'rgb(136, 143, 153)',
    grayDark: '#4E5D78',
    grayLight: '#FAFBFB',
    disabled: '#E1E4E8',
    community: '#337348',
    student: '#F67600',
    society: '#116AD9'
  },
  fontFamily: {
    primary: "inter, sans-serif",
  }
};

export default theme;
